import { createSelector } from 'reselect';
import { lovesSelector } from 'selectors/loves/lovesSelector';

const currentProductSelector = createSelector(lovesSelector, loves => loves.currentProduct || null);

export { currentProductSelector };
